import { Routes } from "@angular/router";
import { AdminGuard } from "../guard/admin.guard";

export const content: Routes = [
  {
    path: "pages",
    loadChildren: () => import("../../components/dashboard/dashboard.routes"),
  },
  {
    path: "anagrafiche",
    loadChildren: () =>
      import("../../components/anagrafiche/anagrafiche-page.routes"),
    canActivate: [AdminGuard],
    data: {
      title: "routes.user_records",
      //breadcrumb: "Anagrafiche",
      roles: ["admin"],
    },
  },
  {
    path: "progetti",
    loadChildren: () =>
      import("../../components/progetti/progetti-page.routes"),
    data: {
      title: "routes.projects",
      //breadcrumb: "Progetti",
    },
  },
  {
    path: "obiettivi-realizzativi",
    loadChildren: () =>
      import(
        "../../components/progetti/obiettivi-realizzativi/obiettivi-page.routes"
      ),
    data: {
      title: "routes.objectives",
      //breadcrumb: "Progetti",
      roles: ["admin", "project_leader"],
    },
  },
  {
    path: "stazione-appaltante",
    loadChildren: () =>
      import(
        "../../components/stazione-appaltante/stazione-appaltante-page.routes"
      ),
    data: {
      title: "routes.contracting_station",
      roles: ["admin"],
    },
  },
  {
    path: "cig",
    loadChildren: () => import("../../components/progetti/cig/cig-page.routes"),
    data: {
      title: "routes.cig",
      roles: ["admin"],
    },
  },
  {
    path: "documents",
    loadChildren: () => import("../../components/documents/documents-page.routes"),
    data: {
      title: "routes.documents",
      roles: ["admin", "project_leader", "employee", "guest"],
    },
  },
];
